import { VinoDataSKU } from "../../types/vino-data-types";
import { Wine } from "../../types";
import { WineAttributesFromVinoDataWine } from "../vino-data/wine-attributes";
import { awardsFromVinoDataWine } from "./awards";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";
import { reviewsFromVinoDataWine } from "./reviews";
import { tastingNotesFromVinoDataWine } from "./tasting-notes";

export const winesFromVinoDataWineSKU = (sku: VinoDataSKU): Array<Wine> => {
  if (!sku) return [];

  return sku.wines.map((wine) => {
    const {
      description,
      name,
      region,
      bottleRRP,
      showRRPMixedCases,
      showTastingAndAwardsMixedCases,
      bottleImage,
      relativeSizedBottleImage,
      secretBottleImage,
      secretRelativeBottleImage,
      varietal,
      category,
      country,
      quantity,
    } = wine;

    return {
      awards: awardsFromVinoDataWine(wine, 95),
      description,
      name,
      region,
      varietal,
      category,
      country,
      reviews: reviewsFromVinoDataWine(wine),
      tastingNotes: tastingNotesFromVinoDataWine(wine),
      wineAttributes: WineAttributesFromVinoDataWine(wine),
      bottleRRP,
      showRRPMixedCases:
        showRRPMixedCases === null || showRRPMixedCases === true ? true : false,
      showTastingAndAwardsMixedCases:
        showTastingAndAwardsMixedCases === null ||
        showTastingAndAwardsMixedCases === true
          ? true
          : false,
      bottleImage: generateStorefrontImage(bottleImage, { height: 400 }),
      relativeSizedBottleImage: generateStorefrontImage(
        relativeSizedBottleImage,
        { width: 330 }
      ),
      secretBottleImage: generateStorefrontImage(secretBottleImage, {
        height: 400,
      }),
      secretRelativeBottleImage: generateStorefrontImage(
        secretRelativeBottleImage,
        { width: 330 }
      ),
      quantity,
    };
  });
};
